<script lang="ts">
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Services
	import { format } from '../../../../services/i18n';
	import { postReq } from 'src/services/http';
	//Helpers
	import { real_id, real_id_z } from '../../../../helpers/interface_helpers';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	//Stores
	//Types
	import type { SettingRequest } from '../../../../types/requests/settings/setting';
	//Design system components
	import { Button, Input, Text } from '@Shelly/shelly-design-system';

	export let device;

	let id = real_id(device.id);

	let settings = readDeviceSettings(id)['Configuration:0'];
	const setting = 85;
	let idleTime = settings[setting];
	let cacheIdle = idleTime;
	let loading = false;

	const min = 3; //originally they are 0, 3-50 but with 0 calibration did not work
	const max = 50;

	$: errorMaxtimeClose =
		idleTime && (+idleTime < min || +idleTime > max)
			? $format('generic_out_of_range', {
					default: `Value out of range`,
				})
			: '';

	const validate = () => {
		if (+idleTime > max) {
			idleTime = max;
		}
		if (+idleTime < min) {
			idleTime = min;
		}
		return idleTime;
	};

	const setIdlePowerPeriod = async () => {
		if (cacheIdle === idleTime) return;
		validate();
		loading = true;

		const params = {
			id: real_id_z(device.id), //gateway's id
			a: 'call', //inclusion command
			cc: 'Configuration', //command class
			m: 'set', //method
			ep: 0, //endpoint
			params: JSON.stringify([{ parameter: setting, value: +idleTime }]), //parameters parameter - setting index, value - setting value
		};
		const res: SettingRequest = await postReq(`/fast/device/zw`, {
			...params,
		});

		if (res.isok) {
			params.m = 'get'; //override method
			params.params = JSON.stringify([+setting]); //override params
			const res_get: SettingRequest = await postReq(`/fast/device/zw`, {
				...params,
			});
		}
		await onSettingsResponse(res, device);
		cacheIdle = idleTime;
		loading = false;
	};

	// TODO: finish texts
</script>

<Text styleType="body-small" class="mb-s"
	>{$format('idle_power_description', {
		values: { value: idleTime, min: min, max: max },
		default:
			'Define the maximum time before the power consumption of the motor is read from the Device, after one of the relays is switched on. If there is no power consumption during the set time (motor is not connected, damaged or requires longer time to start, motor is at the end position), the relay will switch off. This time is defined by entering it manually.',
	})}
</Text>
<Input
	class="mb-s"
	size="m"
	bind:value={idleTime}
	type={'number'}
	{min}
	{max}
	error={errorMaxtimeClose}
	info={$format('idle_power_values_description', {
		default: '3 - 50 = 0.3seconds – 5seconds (100ms resolution)', //'0 = time is set automatically. - removing this zero value because did not work'
	})}
	step={1}
	on:enter={() => {
		idleTime = validate();
	}}
	on:enter={setIdlePowerPeriod}
	id="input-zboutao"
	aria-label={$format('idle_power_description', {
		values: { value: idleTime, min: min, max: max },
		default:
			'Define the maximum time before the power consumption of the motor is read from the Device, after one of the relays is switched on. If there is no power consumption during the set time (motor is not connected, damaged or requires longer time to start, motor is at the end position), the relay will switch off. This time is defined by entering it manually.',
	})}
/>
<Button class="mt-s" {loading} size="m" width="full" on:click={setIdlePowerPeriod}
	>{$format('button_save')}</Button
>
